import L from 'leaflet';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

// Runtime-equivalent van de vroegere leaflet-geoman fork:
// Een route eindigt enkel met een klik op het LAATST geplaatste punt.

const lineDrawProto = L.PM.Draw.Line.prototype;
const originalCreateMarker = lineDrawProto._createMarker;
lineDrawProto._createMarker = function (latlng) {
    const marker = originalCreateMarker.call(this, latlng);

    if (this._shape !== 'Line')
        return marker;

    marker.off('click', this._finishShape, this);
    marker.on('click', () => {
        if (this._markers[this._markers.length - 1] === marker)
            this._finishShape();
    });

    return marker;
};

export function applyDutchLang(map) {
    map.pm.setLang('nl');
}
